import type { ZoriModuleManifest } from "../../app/module-manifest";

export const AUTOMATION_WORKFLOWS_PATH = "/workflows";
export const AUTOMATION_WORKFLOW_EDITOR_PATH = "/workflows/:id/editor";
export const AUTOMATION_PROCESOS_ALIAS_PATH = "/procesos";

/**
 * The Automation module ships the surfaces that have real mounted v2
 * contracts: workflow definitions (`workflows:read`/`workflows:write`
 * enforced server-side) with run inspection, cancellation, and approval
 * decisions. `/procesos` is an owned alias canonicalizing to `/workflows`
 * (the Lit route's primary path). `/cron` and `/jobs` are recorded gaps —
 * both are contract-disabled with unmounted handlers — and
 * `/knowledge/workflow-changes` is an empty stub, so none are consumed here.
 */
export const automationModuleManifest: ZoriModuleManifest = {
  id: "automation",
  labelKey: "zori.modules.automation",
  requiredCapabilities: ["workspace.view"],
  routes: [
    {
      id: "workflows",
      path: AUTOMATION_WORKFLOWS_PATH,
      labelKey: "zori.automation.workflows.page",
      requiredCapabilities: ["workflows:read"],
      navGroup: "automation",
      icon: "run",
    },
    {
      id: "workflow-editor",
      path: AUTOMATION_WORKFLOW_EDITOR_PATH,
      labelKey: "zori.automation.editor.page",
      canonicalRouteId: "automation:workflows",
      requiredCapabilities: ["workflows:read"],
      navHidden: true,
    },
    {
      id: "procesos-alias",
      path: AUTOMATION_PROCESOS_ALIAS_PATH,
      labelKey: "zori.automation.workflows.page",
      canonicalRouteId: "automation:workflows",
      requiredCapabilities: ["workflows:read"],
      navHidden: true,
    },
  ],
};
